import { useTranslation } from "react-i18next";

const useLocalization = (namespace) => {
  const { t, ...rest } = useTranslation();
  const translate = (key, options) => t(`${namespace}.${key}`, options);
  return { t: translate, ...rest };
};

export default useLocalization;
